import { lazyLoad } from 'utils/lazy';

export const DCO = lazyLoad(
  () => import('./DCO'),
  (module) => module.DCO
);
